import { JSX } from 'react'

import {
  Dialog,
  SplitsDialogContent,
} from '~/components/component-library/Dialog'

export const SwitchOrgForAccountDialog = ({
  ownerOrgName,
  onConfirm,
  onCancel,
}: {
  ownerOrgName: string | undefined
  onConfirm: () => void
  onCancel: () => void
}): JSX.Element => {
  return (
    <Dialog
      open
      onOpenChange={(open) => {
        if (!open) onCancel()
      }}
    >
      <SplitsDialogContent
        id="switchOrgForAccount"
        title="Switch workspace?"
        variant="confirmation"
        confirmButton={{
          text: ownerOrgName ? `Switch to ${ownerOrgName}` : 'Switch workspace',
          onClick: onConfirm,
        }}
        cancelButton={{ onClick: onCancel }}
      >
        {`This account isn't owned by your active workspace${
          ownerOrgName ? ` — it belongs to ${ownerOrgName}` : ''
        }. Switch workspaces to view it.`}
      </SplitsDialogContent>
    </Dialog>
  )
}
